export const useAdminAuthStore = defineStore('adminAuth', () => {

    const admin            = ref(null)
    const isAuthenticated       = computed(() => !!admin.value)

    const setAdmin = (userData) => {
        admin.value = userData
    }

    const clearAdmin = () => {
        admin.value = null
    }

    return {
        admin,
        isAuthenticated,
        setAdmin,
        clearAdmin
    }
})